module.exports = __webpack_public_path__ + "img/telefono.9d00554e.svg";